import { FC } from 'react';
import type { LottieOptions } from 'lottie-react';
import styled from 'styled-components';
import LottieIcon from '../LottieIcon';
import { useColorTheme, useFixedSurface } from '../../providers/Theme';
import spinnerDotsWhite from './assets/spinnerDotsWhite.json';
import spinnerDotsDark from './assets/spinnerDotsDark.json';
import spinnerDotsDarkBlue from './assets/spinnerDotsDarkBlue.json';

/** Names the dots' colour: `light` is white dots, for dark surfaces. */
export type tSpinnerVariant = 'dark' | 'darkBlue' | 'light';

export interface ISpinnerProps {
  className?: string;
  variant?: tSpinnerVariant;
}

const SPINNER_ANIMATIONS: Record<tSpinnerVariant, LottieOptions['animationData']> = {
  light: spinnerDotsWhite,
  dark: spinnerDotsDark,
  darkBlue: spinnerDotsDarkBlue
};

const Spinner: FC<ISpinnerProps> = ({ className, variant }) => {
  const { theme } = useColorTheme();
  const isFixedSurface = useFixedSurface();
  const resolved = variant ?? (theme === 'light' && !isFixedSurface ? 'dark' : 'light');

  return (
    <Wrapper className={className}>
      <LottieIcon
        animationJSONData={SPINNER_ANIMATIONS[resolved]}
        loop
        autoPlay
        speed={2}
        height="36px"
        width="72px"
      />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default Spinner;
